import React from 'react'
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl'

function VendingModalCategories({ categories, setGroups, getGroupsByMachineByCategory, getGroupsByMachine }) {


  return (
    <>
      {/*  Modal Info */}
      {/* ==========================================================
    Modal de Categorías
    Lógica preservada: categories, getGroupsByMachine,
    getGroupsByMachineByCategory, Categorie.category_id,
    Categorie.name, Categorie.img, data-bs-dismiss="modal"
    ========================================================== */}
      <div
        className="modal fade"
        id="CategoriesModal"
        tabIndex="-1"
        aria-labelledby="CategoriesModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg vmcat-bootstrap-override">
          <div className="modal-content">

            <div className="vmcat-root">

              {/* ========== HEADER ========== */}
              <header className="vmcat-header">
                <div className="vmcat-header-title-wrap">
                  <span className="vmcat-header-eyebrow">Filtra el menú</span>
                  <h2 className="vmcat-header-title">
                    <i className="uil uil-apps"></i>
                    Categorías
                  </h2>
                </div>
                <button
                  type="button"
                  className="vmcat-close"
                  data-bs-dismiss="modal"
                  aria-label="Cerrar"
                >
                  <i className="uil uil-times"></i>
                </button>
              </header>

              {/* ========== BODY ========== */}
              <div className="vmcat-body">
                <ul className="vmcat-list">

                  {/* Opción "Ver Todos" — destacada */}
                  <li className="vmcat-item vmcat-item-all">
                    <button
                      className="vmcat-card vmcat-card-all"
                      data-bs-dismiss="modal"
                      onClick={() => (getGroupsByMachine())}
                    >
                      <input
                        type="radio"
                        className="vmcat-radio"
                        name="options-categories"
                        key={0}
                        id="cateforieAll"
                        value={"todos"}
                      />
                      <div className="vmcat-card-media vmcat-card-media-all">
                        <i className="uil uil-list-ul"></i>
                      </div>
                      <div className="vmcat-card-content">
                        <span className="vmcat-card-eyebrow">Categoría</span>
                        <h3 className="vmcat-card-name">Ver todos</h3>
                      </div>
                      <span className="vmcat-card-arrow">
                        <i className="uil uil-angle-right-b"></i>
                      </span>
                    </button>
                  </li>

                  {/* Resto de categorías */}
                  {categories.map((Categorie) => (
                    <li className="vmcat-item" key={Categorie.category_id}>
                      <button
                        className="vmcat-card"
                        data-bs-dismiss="modal"
                        value={Categorie.category_id}
                        onClick={() => (getGroupsByMachineByCategory(Categorie.category_id))}
                      >
                        <input
                          type="radio"
                          className="vmcat-radio"
                          name="options-categories"
                          id={'categorie' + Categorie.name}
                          value={Categorie.category_id}
                        />
                        <div className="vmcat-card-media">
                          <img
                            src={buildCloudinaryImageUrl({url: Categorie.img, width: 300, type: "image", quality: "auto"})}
                            alt={Categorie.name}
                            loading="lazy"
                          />
                        </div>
                        <div className="vmcat-card-content">
                          <span className="vmcat-card-eyebrow">Categoría</span>
                          <h3 className="vmcat-card-name" title={Categorie.name}>
                            {Categorie.name}
                          </h3>
                        </div>
                        <span className="vmcat-card-arrow">
                          <i className="uil uil-angle-right-b"></i>
                        </span>
                      </button>
                    </li>
                  ))}

                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default VendingModalCategories